// src/components/MegaMenu.js
import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Container,
  Row,
  Col,
  NavDropdown,
  Tab,
} from "react-bootstrap";
import Logo from "./logo";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Docker from "../assets/images/Docker.svg";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { LinkContainer } from "react-router-bootstrap";
import Card from "react-bootstrap/Card";
import Img1 from "../assets/images/LLM.png";
import Img2 from "../assets/images/NLP.png";
import Img3 from "../assets/images/RAG.png";
import admin from "../../src/assets/images/CEO.png";
import { sub1, sub2, sub3, sub4 } from "./NavData";
import { useLocation, useParams } from "react-router-dom";
const MegaMenu = () => {
  let query = useLocation();

  console.log("params", query);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showEnterpriseMenu, setShowEnterpriseMenu] = useState(false);
  const [showSmartMenu, setShowSmartMenu] = useState(false);
  const [showDigitalintellMenu, setShowDigitalintellMenu] = useState(false);
  const [showAiMenu, setShowAiMenu] = useState(false);
  const [activeMainMenu, setActiveMainMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  console.log("hello", process.env.PUBLIC_URL);
  const [subList, setSubList] = useState("sub4");
  const [logo, setLogo] = useState(false);
  const [childmenu, setChildMenu] = useState("salseforce");
  const [items, setItems] = useState(sub4[0].Items);
  console.log(items);
  const [subListData, setSubListData] = useState(sub4);
  console.log(childmenu);
  function setSublistfun(value) {
    console.log(value);
    switch (value) {
      case "sub1":
        setSubList(value);
        setSubListData(sub1);
        setChildMenu(sub1[0].name);
        setItems(sub1[0].Items);
        break;
      case "sub2":
        setSubList(value);
        setSubListData(sub2);
        setChildMenu(sub2[0].name);
        setItems(sub2[0].Items);

        break;

      case "sub3":
        setSubListData(sub3);
        setSubList(value);
        setChildMenu(sub3[0].name);
        setItems(sub3[0].Items);
        break;

      case "sub4":
        setSubListData(sub4);
        setSubList(value);
        setChildMenu(sub4[0].name);
        setItems(sub4[0].Items);
        break;
      default:
        setSubList([]);
        break;
    }
  }
  const handleEnterpriseClick = () => {
    setShowEnterpriseMenu(prev => !prev);
    setShowDigitalintellMenu(false);
    setShowSmartMenu(false);
    setShowAiMenu(false);
  };
  const handleDigitalintellClick = () => {
    setShowDigitalintellMenu(prev => !prev);
    setShowEnterpriseMenu(false);
    setShowSmartMenu(false);
    setShowAiMenu(false);
  };
  const handleSmartmenuClick = () => {
    setShowSmartMenu(prev => !prev);
    setShowDigitalintellMenu(false);
    setShowEnterpriseMenu(false);
    setShowAiMenu(false);
  };
  const handleAiClick = () => {
    setShowAiMenu(prev => !prev);
    setShowDigitalintellMenu(false);
    setShowEnterpriseMenu(false);
    setShowSmartMenu(false);
  };
  const toggleMegaMenu = (menu) => {
    setLogo(true);
    if (activeMainMenu === menu) {
      setShowMegaMenu(!showMegaMenu);
      setActiveSubMenu(null); // Reset active submenu when toggling mega menu
    } else {
      setShowMegaMenu(true);
      setActiveSubMenu(null);
    }
    setActiveMainMenu(menu);
  };

  const toggleSubMenu = (subMenu) => {
    setActiveSubMenu(activeSubMenu === subMenu ? null : subMenu);
  };
  console.log("console", window.location.href.split("/")[3] == "");
  return (
    <>
      <Navbar
        expand="lg"
        variant="dark"
        className={
          query.pathname === "/"
            ? `bics-navbar ${showMegaMenu ? "show" : ""}`
            : `bics-navbar bg-white position-static bg-lite-grey ${
                showMegaMenu ? "show" : ""
              }`
        }
      >
        <Container>
          <LinkContainer
            onClick={() => {
              setLogo(false);
              setShowMegaMenu(false);
            }}
            className="nav-link"
            to="/"
          >
            <Nav.Link>
              <Logo condition={!logo}></Logo>
            </Nav.Link>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav className="me-auto">
              <ul className="list-group-horizontal mobile_menu_block_scroll mCustomScrollbar"></ul>

              <li>
                <Nav.Link href="" onClick={() => toggleMegaMenu("menu1")}>
                  Solutions &nbsp;
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="angle-down"
                    class="svg-inline--fa fa-angle-down "
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    height={"16px"}
                    width={"16px"}
                  >
                    <path
                      fill="currentColor"
                      d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"
                    ></path>
                  </svg>
                </Nav.Link>
                {showMegaMenu && (
                  <div
                    className={`mobile-menu-show mega-menu ${
                      showMegaMenu ? "show" : ""
                    }`}
                  >
                    <Container>
                      {activeMainMenu === "menu1" && (
                        <Row className="px-3">
                          <Col sm={12} className="px-3 my-3 w-100">
                            <span
                              className="d-flex align-items-center pb-3 px-2"
                              style={{
                                borderBottom: "1px solid #cdcdcd",
                              }}
                              onClick={handleEnterpriseClick}
                            >
                              <span className="icon-menu-1">
                                <svg
                                  width="36"
                                  height="36"
                                  viewBox="0 0 48 48"
                                  fill="white"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_829_2270)">
                                    <path
                                      d="M26.475 37.725C25.425 40.875 22.575 40.875 21.525 37.725L20.625 37.425C20.25 37.275 9.52501 33.525 6.97501 32.625V45.525C6.97501 46.875 8.10001 48 9.45001 48H38.55C39.9 48 41.025 46.875 41.025 45.525V32.625C37.5 33.825 27.75 37.275 27.375 37.425L26.475 37.725Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M24 38.3991C24.375 38.4741 25.125 36.8991 25.125 35.2491C25.125 35.1741 25.125 35.0991 25.125 35.0241C25.125 33.0741 24.3 32.0241 24 32.0241C23.625 31.8741 22.725 33.7491 22.875 35.3991C22.875 37.3491 23.7 38.3991 24 38.3991Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M41.025 18.75H6.975C5.625 18.75 4.5 19.875 4.5 21.225V28.125C4.5 29.175 5.175 30.15 6.15 30.45L6.9 30.75C7.425 30.9 20.175 35.4 21.15 35.775C20.85 33.6 22.05 30.075 23.925 30.225C25.875 30.075 27 33.6 26.7 35.775C27.675 35.475 40.5 30.975 40.95 30.75L41.7 30.525C42.675 30.225 43.425 29.25 43.425 28.2V21.3C43.425 19.95 42.3 18.825 40.95 18.825L41.025 18.75Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M19.125 16.4242H28.8C29.175 16.4242 29.475 16.6492 29.55 17.0242H31.275C31.2 15.7492 30.15 14.6992 28.8 14.6992H19.125C17.85 14.6992 16.725 15.7492 16.65 17.0242H18.375C18.375 16.6492 18.75 16.4242 19.125 16.4242Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M19.875 8.025L18.825 11.925C18.675 12.375 18.975 12.825 19.425 12.975C19.65 12.975 19.875 12.975 20.025 12.975L24 10.875L27.975 12.975C28.425 13.2 28.95 12.975 29.175 12.6C29.25 12.45 29.325 12.225 29.175 12L28.125 8.1L30.75 5.25C31.05 4.875 31.05 4.35 30.75 4.05C30.6 3.9 30.45 3.825 30.225 3.825L26.85 3.525L24.75 0.375C24.45 0 23.925 -0.075 23.55 0.15C23.55 0.15 23.4 0.3 23.325 0.375L21.225 3.525L17.85 3.825C17.55 3.825 17.25 4.05 17.1 4.35C16.95 4.65 17.1 5.025 17.25 5.25L19.875 8.1V8.025Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M47.25 9.37422L44.775 9.14922L43.275 6.82422C42.975 6.44922 42.45 6.37422 42.075 6.59922C42.075 6.59922 41.925 6.74922 41.85 6.82422L40.35 9.14922L37.875 9.37422C37.425 9.37422 37.05 9.82422 37.05 10.2742C37.05 10.4992 37.125 10.6492 37.275 10.7992L39.15 12.8992L38.4 15.7492C38.25 16.1992 38.55 16.6492 39 16.7992C39.225 16.7992 39.45 16.7992 39.6 16.7992L42.525 15.2242L45.45 16.7992C45.9 17.0242 46.35 16.7992 46.575 16.4242C46.65 16.1992 46.725 15.9742 46.575 15.8242L45.825 12.9742L47.7 10.8742C48 10.4992 48 9.97422 47.7 9.67422C47.55 9.52422 47.4 9.44922 47.175 9.44922L47.25 9.37422Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M8.39999 16.7242C8.84999 16.9492 9.29999 16.7242 9.52499 16.3492C9.59999 16.1242 9.67499 15.8992 9.52499 15.7492L8.77499 12.8992L10.65 10.7992C10.95 10.4242 10.95 9.89922 10.65 9.59922C10.5 9.44922 10.35 9.37422 10.125 9.37422L7.64999 9.14922L6.14999 6.82422C5.84999 6.44922 5.32499 6.37422 4.94999 6.59922C4.94999 6.59922 4.79999 6.74922 4.72499 6.82422L3.22499 9.14922L0.749988 9.37422C0.299988 9.37422 -0.0750122 9.82422 -0.0750122 10.2742C-0.0750122 10.4992 -1.22041e-05 10.6492 0.149988 10.7992L2.02499 12.8992L1.27499 15.7492C1.12499 16.1992 1.42499 16.6492 1.87499 16.7992C2.09999 16.7992 2.32499 16.7992 2.47499 16.7992L5.39999 15.2242L8.32499 16.7992L8.39999 16.7242Z"
                                      fill="#B3B3B3"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_829_2270">
                                      <rect
                                        width="48"
                                        height="48"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                              >
                                o Enterprise&nbsp;
                              </span>
                              <i class="bi bi-arrow-up-right-circle-fill"></i>
                            </span>
                            {showEnterpriseMenu && (
                              <ul className="mt-3 px-0">
                                {sub4.map((item, index) => {
                                  return (
                                    <li className="my-0.5 mid-nav-font">
                                      <LinkContainer
                                        onClick={() => setShowMegaMenu(false)}
                                        to={item.route}
                                      >
                                        <Nav.Link
                                          className={`${
                                            window.location.href.split(
                                              "/"
                                            )[3] == item.route.split("/")[1]
                                              ? "text-success"
                                              : "text-black"
                                          }`}
                                        >
                                          {item.lable}
                                        </Nav.Link>
                                      </LinkContainer>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </Col>
                          <Col sm={12} className="px-3 pb-3 w-100">
                            <span
                              className="d-flex align-items-center px-2 pb-3"
                              style={{
                                borderBottom: "1px solid #cdcdcd",
                              }}
                              onClick={handleDigitalintellClick}
                            >
                              <span className="icon-menu-1">
                                <svg
                                  width="36"
                                  height="36"
                                  viewBox="0 0 48 48"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_734_6421)">
                                    <path
                                      d="M2 26.4453C2 24.8151 2 23.1869 2 21.5566C2.25618 21.4686 2.16947 21.2435 2.19706 21.0654C3.34987 13.6287 7.2182 8.07463 13.8828 4.47173C15.3214 3.69283 16.8427 3.09398 18.4448 2.74954C19.4695 2.53036 20.5278 2.45403 21.4953 2C23.0699 2 24.6464 2 26.2209 2C26.2899 2.05871 26.3529 2.16243 26.4258 2.17026C31.4115 2.72019 35.672 4.71441 39.2368 8.26055C40.6143 9.63243 41.911 11.0435 42.8943 12.703C45.5645 17.212 46.5005 22.0733 45.7497 27.2516C44.4393 36.2814 37.6938 43.493 28.7492 45.4716C27.9077 45.6575 27.019 45.6184 26.2209 45.9961H21.4953C21.4106 45.7378 21.18 45.8239 21.0047 45.7945C11.8196 44.1819 5.75797 38.9879 2.8986 30.1617C2.50645 28.9523 2.29559 27.6841 2 26.4414L2 26.4453ZM24.2779 7.83196C15.2623 7.86327 8.0971 14.9184 8.13848 23.772C8.17789 32.5552 15.0869 40.8021 26.4948 39.8353C30.0656 39.534 33.2422 37.7237 35.7922 35.0719C38.8486 31.8937 40.4409 28.1127 40.4251 23.7153C40.3916 14.9438 33.1043 7.79869 24.2798 7.83001L24.2779 7.83196Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M37.5755 30.9445C36.8129 30.4768 36.0739 30.058 35.3723 29.5824C34.9112 29.2712 34.7161 29.373 34.3989 29.8251C32.2213 32.925 29.4979 35.3654 25.6395 36.0915C21.9012 36.7941 18.3422 36.1913 15.1183 34.0718C14.9823 33.9818 14.8483 33.882 14.734 33.7665C14.5803 33.6119 14.2867 33.4573 14.4227 33.2205C14.602 32.9094 14.8641 33.1188 15.0927 33.244C17.2545 34.4241 19.5936 34.6922 22.0194 34.6824C27.7047 34.6629 33.7722 29.6078 34.6117 24.3493C34.6964 23.8189 34.4324 23.0596 34.9073 22.8032C35.3664 22.5547 36.0581 22.723 36.6473 22.7191C37.4021 22.7132 38.1568 22.7289 38.9116 22.7132C39.2604 22.7054 39.4456 22.7797 39.4634 23.1829C39.5914 25.9462 39.0278 28.5334 37.5735 30.9425L37.5755 30.9445Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M9.92141 29.1992C10.552 30.0388 11.1787 30.8803 11.8152 31.7179C13.0153 33.2992 14.6154 34.354 16.3831 35.2191C19.27 36.632 22.358 37.0293 25.4814 36.7025C27.123 36.5303 28.6817 35.7044 30.1006 34.7729C31.7578 33.6867 33.1865 32.354 34.3571 30.7629C34.7906 30.1738 35.0862 29.9312 35.8922 30.4302C37.8372 31.6396 37.8904 31.5692 36.4223 33.2757C33.3087 36.8904 29.4719 39.184 24.5966 39.3699C18.4365 39.6028 13.9277 36.8317 10.8555 31.6181C10.4771 30.9762 10.1874 30.2815 9.86229 29.6102C9.81105 29.5045 9.78938 29.3851 9.75391 29.2716C9.81105 29.2481 9.86623 29.2266 9.92338 29.2031L9.92141 29.1992Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M20.6162 33.9972C21.5996 33.778 22.5987 33.6254 23.5367 33.2673C28.2603 31.455 31.293 28.1868 32.1936 23.1592C32.4853 21.5251 32.1187 19.9751 31.0388 18.6678C30.6979 18.2549 30.692 18.1022 31.1788 17.8282C32.6291 17.0102 34.0519 16.1413 35.4747 15.2762C36.0304 14.9377 36.4029 14.9259 36.8561 15.5326C38.1705 17.292 39.008 19.2295 39.3864 21.3783C39.4849 21.9321 39.4159 22.2022 38.7302 22.1728C37.3882 22.1161 36.0403 22.1709 34.6943 22.1474C34.2273 22.1396 34.0007 22.2139 33.979 22.7678C33.7208 29.5411 28.879 32.8974 23.3416 33.917C22.4351 34.0833 21.5326 34.1303 20.6143 33.9953L20.6162 33.9972Z"
                                      fill="#B3B3B3"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_734_6421">
                                      <rect
                                        width="48"
                                        height="48"
                                        rx="8"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              <span></span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                                className="text-nowrap"
                              >
                                Digital Intelligence Experience Platform
                              </span>
                            </span>
                            {showDigitalintellMenu && (
                              <ul className="mt-3 px-0">
                                {sub1.map((item, index) => {
                                  return (
                                    <li className="my-0.5 mid-nav-font">
                                      <LinkContainer
                                        onClick={() => setShowMegaMenu(false)}
                                        to={item.route}
                                      >
                                        <Nav.Link
                                          className={`${
                                            window.location.href.split(
                                              "/"
                                            )[3] == item.route.split("/")[1]
                                              ? "text-success"
                                              : "text-black"
                                          }`}
                                        >
                                          {item.lable}
                                        </Nav.Link>
                                      </LinkContainer>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </Col>
                          <Col sm={12} className="px-3 pb-3 w-100">
                            <span
                              className="d-flex align-items-center px-2 pb-3"
                              style={{
                                borderBottom: "1px solid #cdcdcd",
                              }}
                              onClick={handleSmartmenuClick}
                            >
                              <span className="icon-menu-1">
                                <svg
                                  width="36"
                                  height="36"
                                  viewBox="0 0 48 48"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_734_4421)">
                                    <path
                                      d="M29.0147 43.2634C28.8581 43.0112 28.5825 42.8574 28.2862 42.8574H19.7147C19.2412 42.8574 18.8578 43.2418 18.8578 43.7152C18.8578 43.8484 18.8887 43.9787 18.9478 44.0977L20.6625 47.5262C20.8078 47.8168 21.104 47.9996 21.4284 48.0005H26.5715C26.8959 48.0005 27.1931 47.8168 27.3375 47.5262L29.0522 44.0977C29.1853 43.8324 29.1712 43.5165 29.0156 43.2634H29.0147Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M35.7084 21.3206C35.7112 24.3094 34.5656 27.1856 32.5078 29.3531C31.1071 30.8081 30.1321 32.6203 29.6896 34.5909C29.5396 35.265 29.4637 35.9531 29.4637 36.6441V36.9328C29.4628 37.3631 29.114 37.7119 28.6828 37.7138H19.3153C18.885 37.7128 18.5362 37.3641 18.5343 36.9328V36.6441C18.5343 35.9541 18.464 35.2659 18.3234 34.5909C17.8987 32.6381 16.9359 30.8419 15.5446 29.4075C11.0615 24.7519 11.2012 17.3447 15.8568 12.8616C20.384 8.50219 27.5456 8.4975 32.0793 12.8503C34.409 15.0497 35.7234 18.1163 35.7093 21.3206H35.7084Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M30.0009 36H17.9999C17.5267 36 17.1431 36.3836 17.1431 36.8569V43.7147C17.1431 44.1879 17.5267 44.5716 17.9999 44.5716H30.0009C30.4741 44.5716 30.8578 44.1879 30.8578 43.7147V36.8569C30.8578 36.3836 30.4741 36 30.0009 36Z"
                                      fill="#E0E0E0"
                                    />
                                    <path
                                      d="M23.9999 5.14313C23.5265 5.14313 23.1431 4.75969 23.1431 4.28625V0.856875C23.1431 0.383438 23.5265 0 23.9999 0C24.4734 0 24.8568 0.383438 24.8568 0.856875V4.28531C24.8568 4.75875 24.4734 5.14219 23.9999 5.14219V5.14313Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M11.146 7.7179C10.9182 7.7179 10.7007 7.6279 10.5404 7.46665L6.90379 3.83009C6.56348 3.50102 6.5541 2.95821 6.88316 2.6179C7.21223 2.27759 7.75504 2.26821 8.09535 2.59727C8.10285 2.60384 8.10941 2.61134 8.11598 2.6179L11.7525 6.25446C12.0872 6.58915 12.0872 7.13196 11.7525 7.46665C11.5922 7.62696 11.3738 7.7179 11.1469 7.7179H11.146Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M7.51032 37.0617C7.03688 37.0617 6.65344 36.6774 6.65344 36.2049C6.65344 35.978 6.74344 35.7605 6.90375 35.6002L10.5403 31.9636C10.8694 31.6233 11.4122 31.6139 11.7525 31.943C12.0928 32.272 12.1022 32.8149 11.7731 33.1552C11.7666 33.1627 11.7591 33.1692 11.7525 33.1758L8.11594 36.8124C7.95563 36.9736 7.73719 37.0636 7.51032 37.0636V37.0617Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M36.8541 7.71794C36.3806 7.71794 35.9972 7.33356 35.9972 6.86106C35.9972 6.63419 36.0872 6.41575 36.2484 6.25544L39.885 2.61888C40.2141 2.27856 40.7569 2.26919 41.0972 2.59825C41.4375 2.92731 41.4469 3.47013 41.1178 3.81044C41.1113 3.81794 41.1038 3.8245 41.0972 3.83106L37.4606 7.46763C37.3003 7.62888 37.0819 7.71888 36.855 7.71888L36.8541 7.71794Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M40.4896 37.0617C40.2628 37.0617 40.0453 36.9717 39.885 36.8114L36.2484 33.1748C35.9081 32.8458 35.8987 32.3029 36.2278 31.9626C36.5568 31.6223 37.0996 31.6129 37.44 31.942C37.4475 31.9486 37.454 31.9561 37.4606 31.9626L41.0971 35.5992C41.4318 35.9339 41.4318 36.4767 41.0971 36.8114C40.9368 36.9717 40.7184 37.0626 40.4915 37.0626L40.4896 37.0617Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M4.28531 20.5712H0.856875C0.383437 20.5712 0 20.1877 0 19.7143C0 19.2409 0.383437 18.8574 0.856875 18.8574H4.28531C4.75875 18.8574 5.14219 19.2409 5.14219 19.7143C5.14219 20.1877 4.75875 20.5712 4.28531 20.5712Z"
                                      fill="#B3B3B3"
                                    />
                                    <path
                                      d="M47.1431 20.5712H43.7147C43.2412 20.5712 42.8578 20.1877 42.8578 19.7143C42.8578 19.2409 43.2412 18.8574 43.7147 18.8574H47.1431C47.6165 18.8574 48 19.2409 48 19.7143C48 20.1877 47.6165 20.5712 47.1431 20.5712Z"
                                      fill="#B3B3B3"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_734_4421">
                                      <rect
                                        width="48"
                                        height="48"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                              >
                                Futuristic Solution&nbsp;
                              </span>
                            </span>
                            {showSmartMenu && (
                              <ul className="mt-3 px-0">
                                {sub2.map((item, index) => {
                                  return (
                                    <li className="my-0.5 mid-nav-font">
                                      <LinkContainer
                                        onClick={() => setShowMegaMenu(false)}
                                        to={item.route}
                                      >
                                        <Nav.Link
                                          className={`${
                                            window.location.href.split(
                                              "/"
                                            )[3] == item.route.split("/")[1]
                                              ? "text-success"
                                              : "text-black"
                                          }`}
                                        >
                                          {item.lable}
                                        </Nav.Link>
                                      </LinkContainer>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </Col>
                          <Col sm={12} className="px-3 pb-3 w-100">
                            {/* <span className="d-flex align-items-center px-2 pb-3"
                    style={{
                      borderBottom: "1px solid #cdcdcd",
                    }}
                     onClick={handleAiClick}>
                      <span className="icon-menu-1">
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 48 48"
                          fill="green"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M30 4.5H25.5V0H22.5V4.5H18V0H15V4.5H12C10.0125 4.5 8.10004 5.2905 6.69754 6.69675C5.28754 8.103 4.5 10.011 4.5 12V15H0V18H4.5V22.5H0V25.5H4.5V30H0V33H4.5V36C4.5 37.989 5.28754 39.897 6.69754 41.3032C8.10004 42.7095 10.0125 43.5 12 43.5H15V48H18V43.5H22.5V48H25.5V43.5H30V48H33V43.5H36C37.9875 43.5 39.9 42.7095 41.3025 41.3032C42.7125 39.897 43.5 37.989 43.5 36V33H48V30H43.5V25.5H48V22.5H43.5V18H48V15H43.5V12C43.5 10.011 42.7125 8.103 41.3025 6.69675C39.9 5.2905 37.9875 4.5 36 4.5H33V0H30V4.5ZM30 15V33H33V15H30ZM15 20.25V33H18V27.75H22.5V33H25.5V20.25C25.5 17.3505 23.1525 15 20.25 15C17.3475 15 15 17.3505 15 20.25ZM22.5 24.75V20.25C22.5 19.0072 21.495 18 20.25 18C19.005 18 18 19.0072 18 20.25V24.75H22.5Z"
                            fill="#B3B3B3"
                          />
                        </svg>
                      </span>

                      <span
                        style={{
                          fontSize: "1rem",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        Artificial Intelligence&nbsp;
                      </span>
                    </span> */}
                            {/* {showAiMenu && (
                    <ul className="mt-3 px-0">
                      {sub3.map((item, index) => {
                        return (
                          <li className="my-0.5 mid-nav-font">
                            <LinkContainer
                              onClick={() => setShowMegaMenu(false)}
                              to={item.route}
                            >
                              <Nav.Link
                                className={`${
                                  window.location.href.split("/")[3] ==
                                  item.route.split("/")[1]
                                    ? "text-success"
                                    : "text-black"
                                }`}
                              >
                                {item.lable}
                              </Nav.Link>
                            </LinkContainer>
                          </li>
                        );
                      })}
                    </ul>
                    )} */}
                          </Col>
                        </Row>
                      )}
                    </Container>
                  </div>
                )}
              </li>
              {/* <li>
                <Nav.Link
                  href=""
                  //  onClick={() => toggleMegaMenu('menu2')}
                >
                  Platform &nbsp;
                </Nav.Link>
              </li> */}
              <li>
                <LinkContainer
                  onClick={() => setShowMegaMenu(false)}
                  to="/industry"
                >
                  <Nav.Link>Industry</Nav.Link>
                </LinkContainer>
              </li>

              <li>
                <li className="text-black">
                  <LinkContainer
                    onClick={() => setShowMegaMenu(false)}
                    to="/careers"
                  >
                    <Nav.Link>careers</Nav.Link>
                  </LinkContainer>
                </li>
                <li>
                  <Nav.Link href="http://bitsglobal.in/" target="_blank">
                    Corporate Training
                  </Nav.Link>
                </li>
              </li>
              <li>
                <Nav.Link
                  onClick={() => toggleMegaMenu("menu8")}
                  href=""
                  // onClick={() => toggleMegaMenu('menu4')}
                >
                  <span>About us &nbsp;</span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="angle-down"
                    class="svg-inline--fa fa-angle-down "
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    height={"16px"}
                    width={"16px"}
                  >
                    <path
                      fill="currentColor"
                      d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"
                    ></path>
                  </svg>
                </Nav.Link>

                {showMegaMenu && (
                  <div
                    className={`mobile-menu-show mega-menu ${
                      showMegaMenu ? "show" : ""
                    }`}
                  >
                    <Container>
                      {activeMainMenu === "menu8" && (
                        <Row>
                          <Col className="p-3">
                            <LinkContainer
                              onClick={() => setShowMegaMenu(false)}
                              to={"/meetourteam"}
                            >
                              <Nav.Link
                                className={
                                  window.location.href.split("/")[3] ==
                                  "meetourteam"
                                    ? "text-light p-4 m-2 sub-menu-blue rounded rounded-3 d-flex justify-content-between alignitem svgactive"
                                    : "text-black p-4 m-2  rounded rounded-3 d-flex justify-content-between alignitem"
                                }
                              >
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <span className="d-flex align-items-center">
                                    <svg
                                      width="36"
                                      height="36"
                                      viewBox="0 0 48 48"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_829_2270)">
                                        <path
                                          d="M26.475 37.725C25.425 40.875 22.575 40.875 21.525 37.725L20.625 37.425C20.25 37.275 9.52501 33.525 6.97501 32.625V45.525C6.97501 46.875 8.10001 48 9.45001 48H38.55C39.9 48 41.025 46.875 41.025 45.525V32.625C37.5 33.825 27.75 37.275 27.375 37.425L26.475 37.725Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M24 38.3991C24.375 38.4741 25.125 36.8991 25.125 35.2491C25.125 35.1741 25.125 35.0991 25.125 35.0241C25.125 33.0741 24.3 32.0241 24 32.0241C23.625 31.8741 22.725 33.7491 22.875 35.3991C22.875 37.3491 23.7 38.3991 24 38.3991Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M41.025 18.75H6.975C5.625 18.75 4.5 19.875 4.5 21.225V28.125C4.5 29.175 5.175 30.15 6.15 30.45L6.9 30.75C7.425 30.9 20.175 35.4 21.15 35.775C20.85 33.6 22.05 30.075 23.925 30.225C25.875 30.075 27 33.6 26.7 35.775C27.675 35.475 40.5 30.975 40.95 30.75L41.7 30.525C42.675 30.225 43.425 29.25 43.425 28.2V21.3C43.425 19.95 42.3 18.825 40.95 18.825L41.025 18.75Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M19.125 16.4242H28.8C29.175 16.4242 29.475 16.6492 29.55 17.0242H31.275C31.2 15.7492 30.15 14.6992 28.8 14.6992H19.125C17.85 14.6992 16.725 15.7492 16.65 17.0242H18.375C18.375 16.6492 18.75 16.4242 19.125 16.4242Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M19.875 8.025L18.825 11.925C18.675 12.375 18.975 12.825 19.425 12.975C19.65 12.975 19.875 12.975 20.025 12.975L24 10.875L27.975 12.975C28.425 13.2 28.95 12.975 29.175 12.6C29.25 12.45 29.325 12.225 29.175 12L28.125 8.1L30.75 5.25C31.05 4.875 31.05 4.35 30.75 4.05C30.6 3.9 30.45 3.825 30.225 3.825L26.85 3.525L24.75 0.375C24.45 0 23.925 -0.075 23.55 0.15C23.55 0.15 23.4 0.3 23.325 0.375L21.225 3.525L17.85 3.825C17.55 3.825 17.25 4.05 17.1 4.35C16.95 4.65 17.1 5.025 17.25 5.25L19.875 8.1V8.025Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M47.25 9.37422L44.775 9.14922L43.275 6.82422C42.975 6.44922 42.45 6.37422 42.075 6.59922C42.075 6.59922 41.925 6.74922 41.85 6.82422L40.35 9.14922L37.875 9.37422C37.425 9.37422 37.05 9.82422 37.05 10.2742C37.05 10.4992 37.125 10.6492 37.275 10.7992L39.15 12.8992L38.4 15.7492C38.25 16.1992 38.55 16.6492 39 16.7992C39.225 16.7992 39.45 16.7992 39.6 16.7992L42.525 15.2242L45.45 16.7992C45.9 17.0242 46.35 16.7992 46.575 16.4242C46.65 16.1992 46.725 15.9742 46.575 15.8242L45.825 12.9742L47.7 10.8742C48 10.4992 48 9.97422 47.7 9.67422C47.55 9.52422 47.4 9.44922 47.175 9.44922L47.25 9.37422Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M8.39999 16.7242C8.84999 16.9492 9.29999 16.7242 9.52499 16.3492C9.59999 16.1242 9.67499 15.8992 9.52499 15.7492L8.77499 12.8992L10.65 10.7992C10.95 10.4242 10.95 9.89922 10.65 9.59922C10.5 9.44922 10.35 9.37422 10.125 9.37422L7.64999 9.14922L6.14999 6.82422C5.84999 6.44922 5.32499 6.37422 4.94999 6.59922C4.94999 6.59922 4.79999 6.74922 4.72499 6.82422L3.22499 9.14922L0.749988 9.37422C0.299988 9.37422 -0.0750122 9.82422 -0.0750122 10.2742C-0.0750122 10.4992 -1.22041e-05 10.6492 0.149988 10.7992L2.02499 12.8992L1.27499 15.7492C1.12499 16.1992 1.42499 16.6492 1.87499 16.7992C2.09999 16.7992 2.32499 16.7992 2.47499 16.7992L5.39999 15.2242L8.32499 16.7992L8.39999 16.7242Z"
                                          fill="#B3B3B3"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_829_2270">
                                          <rect
                                            width="48"
                                            height="48"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>

                                    <span
                                      style={{
                                        fontSize: "1rem",
                                        marginInline: "1rem",
                                        fontWeight: "700",
                                      }}
                                    >
                                      &nbsp;Meet Our Team&nbsp;
                                    </span>
                                  </span>
                                  <FontAwesomeIcon
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: "700",
                                    }}
                                    icon={faAngleRight}
                                  />
                                </div>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to={"/employee"}>
                              <Nav.Link
                                onClick={() => {
                                  setShowMegaMenu(false);
                                }}
                                className={
                                  subList == "sub1"
                                    ? "text-light p-4 m-2 sub-menu-blue rounded rounded-3 d-flex justify-content-between alignitem svgactive"
                                    : "text-black p-4 m-2  rounded rounded-3 d-flex justify-content-between alignitem"
                                }
                              >
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <span className="d-flex align-items-center">
                                    <svg
                                      width="36"
                                      height="36"
                                      viewBox="0 0 48 48"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_734_6421)">
                                        <path
                                          d="M2 26.4453C2 24.8151 2 23.1869 2 21.5566C2.25618 21.4686 2.16947 21.2435 2.19706 21.0654C3.34987 13.6287 7.2182 8.07463 13.8828 4.47173C15.3214 3.69283 16.8427 3.09398 18.4448 2.74954C19.4695 2.53036 20.5278 2.45403 21.4953 2C23.0699 2 24.6464 2 26.2209 2C26.2899 2.05871 26.3529 2.16243 26.4258 2.17026C31.4115 2.72019 35.672 4.71441 39.2368 8.26055C40.6143 9.63243 41.911 11.0435 42.8943 12.703C45.5645 17.212 46.5005 22.0733 45.7497 27.2516C44.4393 36.2814 37.6938 43.493 28.7492 45.4716C27.9077 45.6575 27.019 45.6184 26.2209 45.9961H21.4953C21.4106 45.7378 21.18 45.8239 21.0047 45.7945C11.8196 44.1819 5.75797 38.9879 2.8986 30.1617C2.50645 28.9523 2.29559 27.6841 2 26.4414L2 26.4453ZM24.2779 7.83196C15.2623 7.86327 8.0971 14.9184 8.13848 23.772C8.17789 32.5552 15.0869 40.8021 26.4948 39.8353C30.0656 39.534 33.2422 37.7237 35.7922 35.0719C38.8486 31.8937 40.4409 28.1127 40.4251 23.7153C40.3916 14.9438 33.1043 7.79869 24.2798 7.83001L24.2779 7.83196Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M37.5755 30.9445C36.8129 30.4768 36.0739 30.058 35.3723 29.5824C34.9112 29.2712 34.7161 29.373 34.3989 29.8251C32.2213 32.925 29.4979 35.3654 25.6395 36.0915C21.9012 36.7941 18.3422 36.1913 15.1183 34.0718C14.9823 33.9818 14.8483 33.882 14.734 33.7665C14.5803 33.6119 14.2867 33.4573 14.4227 33.2205C14.602 32.9094 14.8641 33.1188 15.0927 33.244C17.2545 34.4241 19.5936 34.6922 22.0194 34.6824C27.7047 34.6629 33.7722 29.6078 34.6117 24.3493C34.6964 23.8189 34.4324 23.0596 34.9073 22.8032C35.3664 22.5547 36.0581 22.723 36.6473 22.7191C37.4021 22.7132 38.1568 22.7289 38.9116 22.7132C39.2604 22.7054 39.4456 22.7797 39.4634 23.1829C39.5914 25.9462 39.0278 28.5334 37.5735 30.9425L37.5755 30.9445Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M9.92141 29.1992C10.552 30.0388 11.1787 30.8803 11.8152 31.7179C13.0153 33.2992 14.6154 34.354 16.3831 35.2191C19.27 36.632 22.358 37.0293 25.4814 36.7025C27.123 36.5303 28.6817 35.7044 30.1006 34.7729C31.7578 33.6867 33.1865 32.354 34.3571 30.7629C34.7906 30.1738 35.0862 29.9312 35.8922 30.4302C37.8372 31.6396 37.8904 31.5692 36.4223 33.2757C33.3087 36.8904 29.4719 39.184 24.5966 39.3699C18.4365 39.6028 13.9277 36.8317 10.8555 31.6181C10.4771 30.9762 10.1874 30.2815 9.86229 29.6102C9.81105 29.5045 9.78938 29.3851 9.75391 29.2716C9.81105 29.2481 9.86623 29.2266 9.92338 29.2031L9.92141 29.1992Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M20.6162 33.9972C21.5996 33.778 22.5987 33.6254 23.5367 33.2673C28.2603 31.455 31.293 28.1868 32.1936 23.1592C32.4853 21.5251 32.1187 19.9751 31.0388 18.6678C30.6979 18.2549 30.692 18.1022 31.1788 17.8282C32.6291 17.0102 34.0519 16.1413 35.4747 15.2762C36.0304 14.9377 36.4029 14.9259 36.8561 15.5326C38.1705 17.292 39.008 19.2295 39.3864 21.3783C39.4849 21.9321 39.4159 22.2022 38.7302 22.1728C37.3882 22.1161 36.0403 22.1709 34.6943 22.1474C34.2273 22.1396 34.0007 22.2139 33.979 22.7678C33.7208 29.5411 28.879 32.8974 23.3416 33.917C22.4351 34.0833 21.5326 34.1303 20.6143 33.9953L20.6162 33.9972Z"
                                          fill="#B3B3B3"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_734_6421">
                                          <rect
                                            width="48"
                                            height="48"
                                            rx="8"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <span></span>
                                    <span
                                      style={{
                                        fontSize: "1rem",
                                        marginInline: "1rem",
                                        fontWeight: "700",
                                      }}
                                      className="text-nowrap"
                                    >
                                      Employee And Customers
                                    </span>
                                  </span>
                                  <FontAwesomeIcon
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: "700",
                                    }}
                                    icon={faAngleRight}
                                  />
                                </div>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to={"/benefits"}>
                              <Nav.Link
                                onClick={() => {
                                  setShowMegaMenu(false);
                                }}
                                className={
                                  subList == "sub2"
                                    ? "text-light p-4 m-2 sub-menu-blue rounded rounded-3 d-flex justify-content-between alignitem svgactive"
                                    : "text-black p-4 m-2  rounded rounded-3 d-flex justify-content-between alignitem"
                                }
                              >
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <span className="d-flex align-items-center">
                                    <svg
                                      width="36"
                                      height="36"
                                      viewBox="0 0 48 48"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_734_4421)">
                                        <path
                                          d="M29.0147 43.2634C28.8581 43.0112 28.5825 42.8574 28.2862 42.8574H19.7147C19.2412 42.8574 18.8578 43.2418 18.8578 43.7152C18.8578 43.8484 18.8887 43.9787 18.9478 44.0977L20.6625 47.5262C20.8078 47.8168 21.104 47.9996 21.4284 48.0005H26.5715C26.8959 48.0005 27.1931 47.8168 27.3375 47.5262L29.0522 44.0977C29.1853 43.8324 29.1712 43.5165 29.0156 43.2634H29.0147Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M35.7084 21.3206C35.7112 24.3094 34.5656 27.1856 32.5078 29.3531C31.1071 30.8081 30.1321 32.6203 29.6896 34.5909C29.5396 35.265 29.4637 35.9531 29.4637 36.6441V36.9328C29.4628 37.3631 29.114 37.7119 28.6828 37.7138H19.3153C18.885 37.7128 18.5362 37.3641 18.5343 36.9328V36.6441C18.5343 35.9541 18.464 35.2659 18.3234 34.5909C17.8987 32.6381 16.9359 30.8419 15.5446 29.4075C11.0615 24.7519 11.2012 17.3447 15.8568 12.8616C20.384 8.50219 27.5456 8.4975 32.0793 12.8503C34.409 15.0497 35.7234 18.1163 35.7093 21.3206H35.7084Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M30.0009 36H17.9999C17.5267 36 17.1431 36.3836 17.1431 36.8569V43.7147C17.1431 44.1879 17.5267 44.5716 17.9999 44.5716H30.0009C30.4741 44.5716 30.8578 44.1879 30.8578 43.7147V36.8569C30.8578 36.3836 30.4741 36 30.0009 36Z"
                                          fill="#E0E0E0"
                                        />
                                        <path
                                          d="M23.9999 5.14313C23.5265 5.14313 23.1431 4.75969 23.1431 4.28625V0.856875C23.1431 0.383438 23.5265 0 23.9999 0C24.4734 0 24.8568 0.383438 24.8568 0.856875V4.28531C24.8568 4.75875 24.4734 5.14219 23.9999 5.14219V5.14313Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M11.146 7.7179C10.9182 7.7179 10.7007 7.6279 10.5404 7.46665L6.90379 3.83009C6.56348 3.50102 6.5541 2.95821 6.88316 2.6179C7.21223 2.27759 7.75504 2.26821 8.09535 2.59727C8.10285 2.60384 8.10941 2.61134 8.11598 2.6179L11.7525 6.25446C12.0872 6.58915 12.0872 7.13196 11.7525 7.46665C11.5922 7.62696 11.3738 7.7179 11.1469 7.7179H11.146Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M7.51032 37.0617C7.03688 37.0617 6.65344 36.6774 6.65344 36.2049C6.65344 35.978 6.74344 35.7605 6.90375 35.6002L10.5403 31.9636C10.8694 31.6233 11.4122 31.6139 11.7525 31.943C12.0928 32.272 12.1022 32.8149 11.7731 33.1552C11.7666 33.1627 11.7591 33.1692 11.7525 33.1758L8.11594 36.8124C7.95563 36.9736 7.73719 37.0636 7.51032 37.0636V37.0617Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M36.8541 7.71794C36.3806 7.71794 35.9972 7.33356 35.9972 6.86106C35.9972 6.63419 36.0872 6.41575 36.2484 6.25544L39.885 2.61888C40.2141 2.27856 40.7569 2.26919 41.0972 2.59825C41.4375 2.92731 41.4469 3.47013 41.1178 3.81044C41.1113 3.81794 41.1038 3.8245 41.0972 3.83106L37.4606 7.46763C37.3003 7.62888 37.0819 7.71888 36.855 7.71888L36.8541 7.71794Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M40.4896 37.0617C40.2628 37.0617 40.0453 36.9717 39.885 36.8114L36.2484 33.1748C35.9081 32.8458 35.8987 32.3029 36.2278 31.9626C36.5568 31.6223 37.0996 31.6129 37.44 31.942C37.4475 31.9486 37.454 31.9561 37.4606 31.9626L41.0971 35.5992C41.4318 35.9339 41.4318 36.4767 41.0971 36.8114C40.9368 36.9717 40.7184 37.0626 40.4915 37.0626L40.4896 37.0617Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M4.28531 20.5712H0.856875C0.383437 20.5712 0 20.1877 0 19.7143C0 19.2409 0.383437 18.8574 0.856875 18.8574H4.28531C4.75875 18.8574 5.14219 19.2409 5.14219 19.7143C5.14219 20.1877 4.75875 20.5712 4.28531 20.5712Z"
                                          fill="#B3B3B3"
                                        />
                                        <path
                                          d="M47.1431 20.5712H43.7147C43.2412 20.5712 42.8578 20.1877 42.8578 19.7143C42.8578 19.2409 43.2412 18.8574 43.7147 18.8574H47.1431C47.6165 18.8574 48 19.2409 48 19.7143C48 20.1877 47.6165 20.5712 47.1431 20.5712Z"
                                          fill="#B3B3B3"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_734_4421">
                                          <rect
                                            width="48"
                                            height="48"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <span
                                      style={{
                                        fontSize: "1rem",
                                        marginInline: "1rem",
                                        fontWeight: "700",
                                      }}
                                    >
                                      &nbsp;Benefits&nbsp;
                                    </span>
                                  </span>
                                  <FontAwesomeIcon
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: "700",
                                    }}
                                    icon={faAngleRight}
                                  />
                                </div>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to={"/events"}>
                              <Nav.Link
                                onClick={() => {
                                  setShowMegaMenu(false);
                                }}
                                className={
                                  subList == "sub3"
                                    ? "text-light p-4 m-2 sub-menu-blue rounded rounded-3 d-flex justify-content-between alignitem svgactive"
                                    : "text-black p-4 m-2  rounded rounded-3 d-flex justify-content-between alignitem"
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <svg
                                    width="36"
                                    height="36"
                                    viewBox="0 0 48 48"
                                    fill="green"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M30 4.5H25.5V0H22.5V4.5H18V0H15V4.5H12C10.0125 4.5 8.10004 5.2905 6.69754 6.69675C5.28754 8.103 4.5 10.011 4.5 12V15H0V18H4.5V22.5H0V25.5H4.5V30H0V33H4.5V36C4.5 37.989 5.28754 39.897 6.69754 41.3032C8.10004 42.7095 10.0125 43.5 12 43.5H15V48H18V43.5H22.5V48H25.5V43.5H30V48H33V43.5H36C37.9875 43.5 39.9 42.7095 41.3025 41.3032C42.7125 39.897 43.5 37.989 43.5 36V33H48V30H43.5V25.5H48V22.5H43.5V18H48V15H43.5V12C43.5 10.011 42.7125 8.103 41.3025 6.69675C39.9 5.2905 37.9875 4.5 36 4.5H33V0H30V4.5ZM30 15V33H33V15H30ZM15 20.25V33H18V27.75H22.5V33H25.5V20.25C25.5 17.3505 23.1525 15 20.25 15C17.3475 15 15 17.3505 15 20.25ZM22.5 24.75V20.25C22.5 19.0072 21.495 18 20.25 18C19.005 18 18 19.0072 18 20.25V24.75H22.5Z"
                                      fill="#B3B3B3"
                                    />
                                  </svg>

                                  <span></span>
                                  <span
                                    style={{
                                      fontSize: "1rem",
                                      marginInline: "1rem",
                                      fontWeight: "700",
                                    }}
                                  >
                                    &nbsp;Events&nbsp;
                                  </span>
                                </span>
                                <FontAwesomeIcon
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "700",
                                  }}
                                  icon={faAngleRight}
                                />
                              </Nav.Link>
                            </LinkContainer>
                          </Col>
                        </Row>
                      )}
                    </Container>
                  </div>
                )}
              </li>
              <li>
                <LinkContainer
                  onClick={() => setShowMegaMenu(false)}
                  to="/contactus"
                >
                  <Nav.Link>Contact us</Nav.Link>
                </LinkContainer>
              </li>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="dektop-mobile-show">
        {showMegaMenu && (
          <div className={`mega-menu ${showMegaMenu ? "show" : ""}`}>
            <Container fluid>
              {activeMainMenu === "menu1" && (
                <Row className="px-3">
                  {/* Agent Force */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">
                        {/* <img src={Img2} alt="icon" width={10} height={10} /> */}
                      </span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        AGENT FORCE
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Salesforce Sales Cloud</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Salesforce Service Cloud</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Integration</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Data Cloud</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Migration</Nav.Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Automation */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">{/* Your SVG icon */}</span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        AUTOMATION
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Marketing Automation- SFMC</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Marketing Automation - Hubspot</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Marketing Automation- Klaviyo</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>RPA</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Testing Automation</Nav.Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Advanced Cloud Services */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">
                        {/* Cloud SVG icon */}
                      </span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        Advanced Cloud Services
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>AWS</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Azure</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>GCP</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>DevOps</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>PAAS</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>DAAS</Nav.Link>
                      </li>
                    </ul>
                  </Col>

                  {/* AI & Data Engineering */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">{/* AI SVG icon */}</span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        AI & Data Engineering
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Gen AI</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>NLP</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>LLM</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Computer Vision</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Data Engineering</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Snowflake</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>AIOps</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Data Analytics</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Databricks</Nav.Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Advanced DIXAP */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">
                        {/* DIXAP SVG icon */}
                      </span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        Advanced DIXAP
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Customer Experience Platform</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Customer E-commerce Platform</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Headless CMS</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Content Full</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Content Stack</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Drupal</Nav.Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Agentic AI */}
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className="px-3 my-3"
                  >
                    <span
                      className="d-flex align-items-center pb-3 px-2"
                      style={{ borderBottom: "1px solid #cdcdcd" }}
                    >
                      <span className="icon-menu-1">{/* AI SVG icon */}</span>
                      <span
                        className="bics-ai-title"
                        style={{
                          fontSize: "14px",
                          marginInline: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        Agentic AI
                      </span>
                    </span>
                    <ul className="mt-3 px-0 menu-linkz">
                      <li className="my-0.5 mid-nav-font">
                        <LinkContainer to={"/agentic"} onClick={() => setShowMegaMenu(false)}>
                          <Nav.Link>Consulting and Strategy</Nav.Link>
                        </LinkContainer>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Custom Development</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Integration</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Optimization</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Maintenance</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Workflow Orchestration</Nav.Link>
                      </li>
                      <li className="my-0.5 mid-nav-font">
                        <Nav.Link>Strategic Decision-Making</Nav.Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              )}
              {activeMainMenu === "menu8" && (
                <Row>
                  <Col className="p-3">
                    <LinkContainer
                      onClick={() => setShowMegaMenu(false)}
                      to={"/meetourteam"}
                    >
                      <Nav.Link
                        className={
                          window.location.href.split("/")[3] == "meetourteam"
                            ? "text-success"
                            : "text-black"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span className="d-flex align-items-start">
                            <span className="icon-menu-1">
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_829_2270)">
                                  <path
                                    d="M26.475 37.725C25.425 40.875 22.575 40.875 21.525 37.725L20.625 37.425C20.25 37.275 9.52501 33.525 6.97501 32.625V45.525C6.97501 46.875 8.10001 48 9.45001 48H38.55C39.9 48 41.025 46.875 41.025 45.525V32.625C37.5 33.825 27.75 37.275 27.375 37.425L26.475 37.725Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M24 38.3991C24.375 38.4741 25.125 36.8991 25.125 35.2491C25.125 35.1741 25.125 35.0991 25.125 35.0241C25.125 33.0741 24.3 32.0241 24 32.0241C23.625 31.8741 22.725 33.7491 22.875 35.3991C22.875 37.3491 23.7 38.3991 24 38.3991Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M41.025 18.75H6.975C5.625 18.75 4.5 19.875 4.5 21.225V28.125C4.5 29.175 5.175 30.15 6.15 30.45L6.9 30.75C7.425 30.9 20.175 35.4 21.15 35.775C20.85 33.6 22.05 30.075 23.925 30.225C25.875 30.075 27 33.6 26.7 35.775C27.675 35.475 40.5 30.975 40.95 30.75L41.7 30.525C42.675 30.225 43.425 29.25 43.425 28.2V21.3C43.425 19.95 42.3 18.825 40.95 18.825L41.025 18.75Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M19.125 16.4242H28.8C29.175 16.4242 29.475 16.6492 29.55 17.0242H31.275C31.2 15.7492 30.15 14.6992 28.8 14.6992H19.125C17.85 14.6992 16.725 15.7492 16.65 17.0242H18.375C18.375 16.6492 18.75 16.4242 19.125 16.4242Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M19.875 8.025L18.825 11.925C18.675 12.375 18.975 12.825 19.425 12.975C19.65 12.975 19.875 12.975 20.025 12.975L24 10.875L27.975 12.975C28.425 13.2 28.95 12.975 29.175 12.6C29.25 12.45 29.325 12.225 29.175 12L28.125 8.1L30.75 5.25C31.05 4.875 31.05 4.35 30.75 4.05C30.6 3.9 30.45 3.825 30.225 3.825L26.85 3.525L24.75 0.375C24.45 0 23.925 -0.075 23.55 0.15C23.55 0.15 23.4 0.3 23.325 0.375L21.225 3.525L17.85 3.825C17.55 3.825 17.25 4.05 17.1 4.35C16.95 4.65 17.1 5.025 17.25 5.25L19.875 8.1V8.025Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M47.25 9.37422L44.775 9.14922L43.275 6.82422C42.975 6.44922 42.45 6.37422 42.075 6.59922C42.075 6.59922 41.925 6.74922 41.85 6.82422L40.35 9.14922L37.875 9.37422C37.425 9.37422 37.05 9.82422 37.05 10.2742C37.05 10.4992 37.125 10.6492 37.275 10.7992L39.15 12.8992L38.4 15.7492C38.25 16.1992 38.55 16.6492 39 16.7992C39.225 16.7992 39.45 16.7992 39.6 16.7992L42.525 15.2242L45.45 16.7992C45.9 17.0242 46.35 16.7992 46.575 16.4242C46.65 16.1992 46.725 15.9742 46.575 15.8242L45.825 12.9742L47.7 10.8742C48 10.4992 48 9.97422 47.7 9.67422C47.55 9.52422 47.4 9.44922 47.175 9.44922L47.25 9.37422Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M8.39999 16.7242C8.84999 16.9492 9.29999 16.7242 9.52499 16.3492C9.59999 16.1242 9.67499 15.8992 9.52499 15.7492L8.77499 12.8992L10.65 10.7992C10.95 10.4242 10.95 9.89922 10.65 9.59922C10.5 9.44922 10.35 9.37422 10.125 9.37422L7.64999 9.14922L6.14999 6.82422C5.84999 6.44922 5.32499 6.37422 4.94999 6.59922C4.94999 6.59922 4.79999 6.74922 4.72499 6.82422L3.22499 9.14922L0.749988 9.37422C0.299988 9.37422 -0.0750122 9.82422 -0.0750122 10.2742C-0.0750122 10.4992 -1.22041e-05 10.6492 0.149988 10.7992L2.02499 12.8992L1.27499 15.7492C1.12499 16.1992 1.42499 16.6492 1.87499 16.7992C2.09999 16.7992 2.32499 16.7992 2.47499 16.7992L5.39999 15.2242L8.32499 16.7992L8.39999 16.7242Z"
                                    fill="#B3B3B3"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_829_2270">
                                    <rect width="48" height="48" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                                className="abot-title"
                              >
                                &nbsp;Meet Our Team&nbsp;
                              </span>
                              <p className="about-text">
                                BICS GLOBAL, Leading software firm in
                                Consulting, Best Build/Delivery, compliant with
                                Expectations of Any Technology.
                              </p>
                            </span>
                          </span>
                        </div>
                      </Nav.Link>
                    </LinkContainer>
                  </Col>
                  <Col className="p-3">
                    <LinkContainer
                      onClick={() => setShowMegaMenu(false)}
                      to={"/employee"}
                    >
                      <Nav.Link
                        className={
                          window.location.href.split("/")[3] == "employee"
                            ? "text-success"
                            : "text-black"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span className="d-flex align-items-start">
                            <span className="icon-menu-1">
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_734_6421)">
                                  <path
                                    d="M2 26.4453C2 24.8151 2 23.1869 2 21.5566C2.25618 21.4686 2.16947 21.2435 2.19706 21.0654C3.34987 13.6287 7.2182 8.07463 13.8828 4.47173C15.3214 3.69283 16.8427 3.09398 18.4448 2.74954C19.4695 2.53036 20.5278 2.45403 21.4953 2C23.0699 2 24.6464 2 26.2209 2C26.2899 2.05871 26.3529 2.16243 26.4258 2.17026C31.4115 2.72019 35.672 4.71441 39.2368 8.26055C40.6143 9.63243 41.911 11.0435 42.8943 12.703C45.5645 17.212 46.5005 22.0733 45.7497 27.2516C44.4393 36.2814 37.6938 43.493 28.7492 45.4716C27.9077 45.6575 27.019 45.6184 26.2209 45.9961H21.4953C21.4106 45.7378 21.18 45.8239 21.0047 45.7945C11.8196 44.1819 5.75797 38.9879 2.8986 30.1617C2.50645 28.9523 2.29559 27.6841 2 26.4414L2 26.4453ZM24.2779 7.83196C15.2623 7.86327 8.0971 14.9184 8.13848 23.772C8.17789 32.5552 15.0869 40.8021 26.4948 39.8353C30.0656 39.534 33.2422 37.7237 35.7922 35.0719C38.8486 31.8937 40.4409 28.1127 40.4251 23.7153C40.3916 14.9438 33.1043 7.79869 24.2798 7.83001L24.2779 7.83196Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M37.5755 30.9445C36.8129 30.4768 36.0739 30.058 35.3723 29.5824C34.9112 29.2712 34.7161 29.373 34.3989 29.8251C32.2213 32.925 29.4979 35.3654 25.6395 36.0915C21.9012 36.7941 18.3422 36.1913 15.1183 34.0718C14.9823 33.9818 14.8483 33.882 14.734 33.7665C14.5803 33.6119 14.2867 33.4573 14.4227 33.2205C14.602 32.9094 14.8641 33.1188 15.0927 33.244C17.2545 34.4241 19.5936 34.6922 22.0194 34.6824C27.7047 34.6629 33.7722 29.6078 34.6117 24.3493C34.6964 23.8189 34.4324 23.0596 34.9073 22.8032C35.3664 22.5547 36.0581 22.723 36.6473 22.7191C37.4021 22.7132 38.1568 22.7289 38.9116 22.7132C39.2604 22.7054 39.4456 22.7797 39.4634 23.1829C39.5914 25.9462 39.0278 28.5334 37.5735 30.9425L37.5755 30.9445Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M9.92141 29.1992C10.552 30.0388 11.1787 30.8803 11.8152 31.7179C13.0153 33.2992 14.6154 34.354 16.3831 35.2191C19.27 36.632 22.358 37.0293 25.4814 36.7025C27.123 36.5303 28.6817 35.7044 30.1006 34.7729C31.7578 33.6867 33.1865 32.354 34.3571 30.7629C34.7906 30.1738 35.0862 29.9312 35.8922 30.4302C37.8372 31.6396 37.8904 31.5692 36.4223 33.2757C33.3087 36.8904 29.4719 39.184 24.5966 39.3699C18.4365 39.6028 13.9277 36.8317 10.8555 31.6181C10.4771 30.9762 10.1874 30.2815 9.86229 29.6102C9.81105 29.5045 9.78938 29.3851 9.75391 29.2716C9.81105 29.2481 9.86623 29.2266 9.92338 29.2031L9.92141 29.1992Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M20.6162 33.9972C21.5996 33.778 22.5987 33.6254 23.5367 33.2673C28.2603 31.455 31.293 28.1868 32.1936 23.1592C32.4853 21.5251 32.1187 19.9751 31.0388 18.6678C30.6979 18.2549 30.692 18.1022 31.1788 17.8282C32.6291 17.0102 34.0519 16.1413 35.4747 15.2762C36.0304 14.9377 36.4029 14.9259 36.8561 15.5326C38.1705 17.292 39.008 19.2295 39.3864 21.3783C39.4849 21.9321 39.4159 22.2022 38.7302 22.1728C37.3882 22.1161 36.0403 22.1709 34.6943 22.1474C34.2273 22.1396 34.0007 22.2139 33.979 22.7678C33.7208 29.5411 28.879 32.8974 23.3416 33.917C22.4351 34.0833 21.5326 34.1303 20.6143 33.9953L20.6162 33.9972Z"
                                    fill="#B3B3B3"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_734_6421">
                                    <rect
                                      width="48"
                                      height="48"
                                      rx="8"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                  display: "flex",
                                }}
                                className="abot-title"
                              >
                                Employee And Customer&nbsp;
                              </span>
                              <p className="about-text">
                                BICS GLOBAL, Shaping the future by empowering
                                businesses with smart technologies.
                              </p>
                            </span>
                          </span>
                        </div>
                      </Nav.Link>
                    </LinkContainer>
                  </Col>
                  <Col className="p-3">
                    <LinkContainer
                      onClick={() => setShowMegaMenu(false)}
                      to={"/benefits"}
                    >
                      <Nav.Link
                        className={
                          window.location.href.split("/")[3] == "benefits"
                            ? "text-success"
                            : "text-black"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span className="d-flex align-items-start">
                            <span className="icon-menu-1">
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_734_4421)">
                                  <path
                                    d="M29.0147 43.2634C28.8581 43.0112 28.5825 42.8574 28.2862 42.8574H19.7147C19.2412 42.8574 18.8578 43.2418 18.8578 43.7152C18.8578 43.8484 18.8887 43.9787 18.9478 44.0977L20.6625 47.5262C20.8078 47.8168 21.104 47.9996 21.4284 48.0005H26.5715C26.8959 48.0005 27.1931 47.8168 27.3375 47.5262L29.0522 44.0977C29.1853 43.8324 29.1712 43.5165 29.0156 43.2634H29.0147Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M35.7084 21.3206C35.7112 24.3094 34.5656 27.1856 32.5078 29.3531C31.1071 30.8081 30.1321 32.6203 29.6896 34.5909C29.5396 35.265 29.4637 35.9531 29.4637 36.6441V36.9328C29.4628 37.3631 29.114 37.7119 28.6828 37.7138H19.3153C18.885 37.7128 18.5362 37.3641 18.5343 36.9328V36.6441C18.5343 35.9541 18.464 35.2659 18.3234 34.5909C17.8987 32.6381 16.9359 30.8419 15.5446 29.4075C11.0615 24.7519 11.2012 17.3447 15.8568 12.8616C20.384 8.50219 27.5456 8.4975 32.0793 12.8503C34.409 15.0497 35.7234 18.1163 35.7093 21.3206H35.7084Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M30.0009 36H17.9999C17.5267 36 17.1431 36.3836 17.1431 36.8569V43.7147C17.1431 44.1879 17.5267 44.5716 17.9999 44.5716H30.0009C30.4741 44.5716 30.8578 44.1879 30.8578 43.7147V36.8569C30.8578 36.3836 30.4741 36 30.0009 36Z"
                                    fill="#E0E0E0"
                                  />
                                  <path
                                    d="M23.9999 5.14313C23.5265 5.14313 23.1431 4.75969 23.1431 4.28625V0.856875C23.1431 0.383438 23.5265 0 23.9999 0C24.4734 0 24.8568 0.383438 24.8568 0.856875V4.28531C24.8568 4.75875 24.4734 5.14219 23.9999 5.14219V5.14313Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M11.146 7.7179C10.9182 7.7179 10.7007 7.6279 10.5404 7.46665L6.90379 3.83009C6.56348 3.50102 6.5541 2.95821 6.88316 2.6179C7.21223 2.27759 7.75504 2.26821 8.09535 2.59727C8.10285 2.60384 8.10941 2.61134 8.11598 2.6179L11.7525 6.25446C12.0872 6.58915 12.0872 7.13196 11.7525 7.46665C11.5922 7.62696 11.3738 7.7179 11.1469 7.7179H11.146Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M7.51032 37.0617C7.03688 37.0617 6.65344 36.6774 6.65344 36.2049C6.65344 35.978 6.74344 35.7605 6.90375 35.6002L10.5403 31.9636C10.8694 31.6233 11.4122 31.6139 11.7525 31.943C12.0928 32.272 12.1022 32.8149 11.7731 33.1552C11.7666 33.1627 11.7591 33.1692 11.7525 33.1758L8.11594 36.8124C7.95563 36.9736 7.73719 37.0636 7.51032 37.0636V37.0617Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M36.8541 7.71794C36.3806 7.71794 35.9972 7.33356 35.9972 6.86106C35.9972 6.63419 36.0872 6.41575 36.2484 6.25544L39.885 2.61888C40.2141 2.27856 40.7569 2.26919 41.0972 2.59825C41.4375 2.92731 41.4469 3.47013 41.1178 3.81044C41.1113 3.81794 41.1038 3.8245 41.0972 3.83106L37.4606 7.46763C37.3003 7.62888 37.0819 7.71888 36.855 7.71888L36.8541 7.71794Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M40.4896 37.0617C40.2628 37.0617 40.0453 36.9717 39.885 36.8114L36.2484 33.1748C35.9081 32.8458 35.8987 32.3029 36.2278 31.9626C36.5568 31.6223 37.0996 31.6129 37.44 31.942C37.4475 31.9486 37.454 31.9561 37.4606 31.9626L41.0971 35.5992C41.4318 35.9339 41.4318 36.4767 41.0971 36.8114C40.9368 36.9717 40.7184 37.0626 40.4915 37.0626L40.4896 37.0617Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M4.28531 20.5712H0.856875C0.383437 20.5712 0 20.1877 0 19.7143C0 19.2409 0.383437 18.8574 0.856875 18.8574H4.28531C4.75875 18.8574 5.14219 19.2409 5.14219 19.7143C5.14219 20.1877 4.75875 20.5712 4.28531 20.5712Z"
                                    fill="#B3B3B3"
                                  />
                                  <path
                                    d="M47.1431 20.5712H43.7147C43.2412 20.5712 42.8578 20.1877 42.8578 19.7143C42.8578 19.2409 43.2412 18.8574 43.7147 18.8574H47.1431C47.6165 18.8574 48 19.2409 48 19.7143C48 20.1877 47.6165 20.5712 47.1431 20.5712Z"
                                    fill="#B3B3B3"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_734_4421">
                                    <rect width="48" height="48" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                                className="abot-title"
                              >
                                Benefits&nbsp;
                              </span>
                              <p className="about-text">
                                BICS GLOBAL, We always motivate our employees
                                and help them fight stress or regain strength.
                              </p>
                            </span>
                          </span>
                        </div>
                      </Nav.Link>
                    </LinkContainer>
                  </Col>
                  <Col className="p-3">
                    <LinkContainer
                      onClick={() => setShowMegaMenu(false)}
                      to={"/events"}
                    >
                      <Nav.Link
                        className={
                          window.location.href.split("/")[3] == "events"
                            ? "text-success"
                            : "text-black"
                        }
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span className="d-flex align-items-start">
                            <span className="icon-menu-1">
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 48 48"
                                fill="green"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M30 4.5H25.5V0H22.5V4.5H18V0H15V4.5H12C10.0125 4.5 8.10004 5.2905 6.69754 6.69675C5.28754 8.103 4.5 10.011 4.5 12V15H0V18H4.5V22.5H0V25.5H4.5V30H0V33H4.5V36C4.5 37.989 5.28754 39.897 6.69754 41.3032C8.10004 42.7095 10.0125 43.5 12 43.5H15V48H18V43.5H22.5V48H25.5V43.5H30V48H33V43.5H36C37.9875 43.5 39.9 42.7095 41.3025 41.3032C42.7125 39.897 43.5 37.989 43.5 36V33H48V30H43.5V25.5H48V22.5H43.5V18H48V15H43.5V12C43.5 10.011 42.7125 8.103 41.3025 6.69675C39.9 5.2905 37.9875 4.5 36 4.5H33V0H30V4.5ZM30 15V33H33V15H30ZM15 20.25V33H18V27.75H22.5V33H25.5V20.25C25.5 17.3505 23.1525 15 20.25 15C17.3475 15 15 17.3505 15 20.25ZM22.5 24.75V20.25C22.5 19.0072 21.495 18 20.25 18C19.005 18 18 19.0072 18 20.25V24.75H22.5Z"
                                  fill="#B3B3B3"
                                />
                              </svg>
                            </span>
                            <span>
                              <span
                                style={{
                                  fontSize: "1rem",
                                  marginInline: "1rem",
                                  fontWeight: "700",
                                }}
                                className="abot-title"
                              >
                                Events&nbsp;
                              </span>
                              <p className="about-text">
                                BICS GLOBAL, Social activity which is organized
                                or funded by a business entity.
                              </p>
                            </span>
                          </span>
                        </div>
                      </Nav.Link>
                    </LinkContainer>
                  </Col>
                </Row>
              )}

              {activeMainMenu === "menu3" && (
                <Row>
                  <Col md={8}>
                    <ul className="mega-menu-li">
                      <li
                        onClick={() => toggleSubMenu("submenu1")}
                        className={
                          activeSubMenu === "submenu1"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Digital CMS&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu1" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">WordPress</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Drupal</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction3">Contentful</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction3">SEO</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction3">Crownpeak</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction3">Strapi</Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu2")}
                        className={
                          activeSubMenu === "submenu2"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Digital Commerce&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu2" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">Magento</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Wordpress</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Prestashop</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                Commerce Tools
                              </Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Shopify</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">VTEX</Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu3")}
                        className={
                          activeSubMenu === "submenu3"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Digital Mobility&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu3" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">Native ios</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                Native Android
                              </Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                React Native
                              </Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Flutter</Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>

                      <li
                        onClick={() => toggleSubMenu("submenu4")}
                        className={
                          activeSubMenu === "submenu4"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          UI/UX&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu4" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">Figma</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Adobe XD</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                Adobe Illustrator
                              </Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                Adobe Photoshop
                              </Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">HTML/CSS</Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu5")}
                        className={
                          activeSubMenu === "submenu5"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Technology&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu5" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">Python</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Dotnet</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">MEAN/MERN</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">AR/VR</Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu6")}
                        className={
                          activeSubMenu === "submenu6"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          LMS&nbsp;
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="fa-right"
                          />
                        </Nav.Link>
                        {activeSubMenu === "submenu6" && (
                          <ul className="submenu">
                            <li>
                              <Nav.Link href="#subaction1">Absorb</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">Moodle</Nav.Link>
                            </li>
                            <li>
                              <Nav.Link href="#subaction2">
                                Compliance Wire
                              </Nav.Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    </ul>
                  </Col>
                  <Col md={4}>
                    <Row>
                      <Col md={6}>
                        <Card className="bics-box-card">
                          <Card.Img variant="top" src={Img1} />
                          <Card.Body className="bics-body-box">
                            <Card.Title>PROJECT OBJECTIVE</Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card className="bics-box-card">
                          <Card.Img variant="top" src={Img2} />
                          <Card.Body className="bics-body-box">
                            <Card.Title>PROJECT OBJECTIVE</Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {activeMainMenu === "menu4" && (
                <Row>
                  <Col md={8}>
                    <ul className="mega-menu-li">
                      <li
                        onClick={() => toggleSubMenu("submenu1")}
                        className={
                          activeSubMenu === "submenu1"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Natural language processing (NLP)
                        </Nav.Link>
                      </li>
                      {/* <li><a href="#action2">Marketing Cloud</a></li> */}
                      <li
                        onClick={() => toggleSubMenu("submenu2")}
                        className={
                          activeSubMenu === "submenu2"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          large language model (LLM)
                        </Nav.Link>
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu3")}
                        className={
                          activeSubMenu === "submenu3"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">
                          Retrieval-augmented generation (RAG)
                        </Nav.Link>
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu4")}
                        className={
                          activeSubMenu === "submenu4"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">Open AI</Nav.Link>
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu5")}
                        className={
                          activeSubMenu === "submenu5"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">MS Copilot</Nav.Link>
                      </li>
                      <li
                        onClick={() => toggleSubMenu("submenu6")}
                        className={
                          activeSubMenu === "submenu6"
                            ? "active menu-list"
                            : "menu-list button_slide slide_down"
                        }
                      >
                        <Nav.Link className="li-menu">Generative AI</Nav.Link>
                      </li>
                    </ul>
                  </Col>
                  <Col md={4}>
                    <Row>
                      <Col md={6}>
                        <Card className="bics-box-card">
                          <Card.Img variant="top" src={Img1} />
                          <Card.Body className="bics-body-box">
                            <Card.Title>PROJECT OBJECTIVE</Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card className="bics-box-card">
                          <Card.Img variant="top" src={Img2} />
                          <Card.Body className="bics-body-box">
                            <Card.Title>PROJECT OBJECTIVE</Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Container>
          </div>
        )}
      </div>
    </>
  );
};

export default MegaMenu;
